import { apiClient } from '../../../../lib/axios';

export interface PushNotificationTemplate {
  id: string;
  name: string;
  title: string;
  body: string;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface TemplateListResponse {
  data: {
    templates: PushNotificationTemplate[];
    page: number;
    page_size: number;
    total: number;
  };
}

export interface TemplatePayload {
  name: string;
  title: string;
  body: string;
}

export const notificationTemplatesApi = {
  list: (params?: { page?: number; page_size?: number; search?: string }) =>
    apiClient.get<TemplateListResponse>('/admin/notification-templates', { params }).then((r) => r.data),

  create: (payload: TemplatePayload) =>
    apiClient.post<{ data: PushNotificationTemplate }>('/admin/notification-templates', payload).then((r) => r.data),

  update: (id: string, payload: TemplatePayload) =>
    apiClient
      .put<{ data: PushNotificationTemplate }>(`/admin/notification-templates/${id}`, payload)
      .then((r) => r.data),

  delete: (id: string) =>
    apiClient.delete<{ status: string }>(`/admin/notification-templates/${id}`).then((r) => r.data),
};
